<div
  [ngClass]="[
    'option-group-item',
    'relative',

    'flex',
    'gap-xs',
    'items-center',

    'surface-container-low',

    'p-b-xs',

    'outline-none',

    'selected:surface-container-highest',

    'state-layer-group'
  ]"
  [class.cursor-pointer]="!disabled && multiple"
  [attr.data-has-leading-icon]="leadingIcon || hasCheckbox ? true : null"
  [class.opacity-disabled]="disabled"
  (click)="onGroupClicked($event)"
  (keydown)="onGroupKeydown($event)"
  [attr.tabindex]="tabIndex"
  #container
  >
  @if (multiple && hasCheckbox) {
    <campus-checkbox
      [checked]="allSelected"
      [disabled]="disabled"
      aria-hidden="true"
      class="pointer-event-none"
      tabindex="-1"
      [indeterminate]="!allSelected && someSelected"
      pseudo
      #pseudoCheckbox
    ></campus-checkbox>
  }

  @if (leadingIcon) {
    <campus-icon [svgIcon]="leadingIcon"></campus-icon>
  }

  <div class="[ stack stack-space-3xs ][ grow ]">
    @if (overline) {
      <span class="[ label-overline ]">{{ overline }}</span>
    }
    @if (label) {
      <span class="[ label-large on-surface-variant ]">{{ label }}</span>
    }
    @if (supportingText) {
      <span class="[ body-small on-surface-variant ]">{{ supportingText }}</span>
    }
  </div>

  @if (trailingSupportingText) {
    <span class="[ label-small on-surface-variant ]">{{ trailingSupportingText }}</span>
  }

  @if (!disabled && multiple) {
    <campus-state-layer [for]="containerRef" class="bg-on-surface"></campus-state-layer>
  }
  <campus-focus-ring [for]="containerRef" inward></campus-focus-ring>
</div>

<ng-content></ng-content>
